module.exports = __webpack_public_path__ + "static/6-5a1dae5d1ad5e7bc147853afb86c699a.jpg";